<template>
<div class="step-wrap step2-recommend" >
  {{ $t('preApprovalLogin.saleData') }}
  <div class="step2-recommend-wrap" style="margin-top: 14px;">
    <i class="el-icon-check"></i>
    <div>
      <div>{{ $t('preApprovalLogin.fundApproval') }}</div>
      <div class="step2-recommend-des">
        {{ $t('preApprovalLogin.fundApplication') }}
      </div>
    </div>
  </div>
  <div class="step2-recommend-wrap">
    <i class="el-icon-check"></i>
    <div>
      <div>{{ $t('preApprovalLogin.financeSolution') }}</div>
      <div class="step2-recommend-des">
        {{ $t('preApprovalLogin.tailorProduct') }}
      </div>
    </div>
  </div>
</div>
</template>
<script >
export default {
  name: 'step2Recommend',
  components: {
    
  },
  data() {
    return {
     
    }
  }
}
</script>

<style lang="scss" scoped>
.step-wrap {
  border: 1px solid #C4C4C480;
  padding: 17px 33px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px 0px #578AD10D;
  &:hover {
    border: 1px solid #5A9CF880
  }
}
.step2-recommend {
  font-size: 12px;
  font-weight: 600;
  line-height: 16.34px;
  margin-top: 19px;
}
.step2-recommend-des {
  color: #7A7A7A;
  margin-top: 8px;
  font-weight: 400;
}

.step2-recommend-wrap {
  display: flex;
  margin-top: 8px;
  .el-icon-check{
    color: #4E78B1;
    font-size: 20px;
    width: 37px;
    flex: 0 0 37px;
  }
}
</style>